export default __webpack_public_path__ + "static/media/wbone.0fdd60e4.png";